export interface FilterProps<T> {
  onSelected: (selectedValue: T) => void;
}

export enum FilterTypes {
  Collection,
}
